"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote, Calendar, ArrowRight, CircleAlert } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Masa Impianti",
  quote: "\"Collaboriamo con Studio MESS per la consulenza in materia di sicurezza sul lavoro nella nostra impresa di impianti elettrici. Il supporto è sempre concreto sia nella gestione della documentazione che negli aggiornamenti normativi. Tecnico disponibile e preparato, con cui è facile confrontarsi per le esigenze operative dell’azienda.\"",
  position: "Amministratore"
}, {
  author: "ATOM SRL",
  quote: "\"Ci siamo affidati a Studio MESS per l’incarico di RSPP esterno. Supporto concreto nella gestione della sicurezza sul lavoro e della documentazione. Tecnico disponibile e preparato.\"",
  position: "\n"
}, {
  author: "Ponteggi Salem",
  quote: "\"Un ottimo servizio si definisce per la capacità di superare le aspettative del cliente.\"",
  position: "Azienda montaggio e smontaggio ponteggi"
}];
function NewsList() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="flex flex-col gap-6">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-3 animate-pulse">
            <div className="flex gap-2">
              <div className="h-6 w-24 bg-muted rounded-none"></div>
              <div className="h-6 w-20 bg-muted rounded-none"></div>
            </div>
            <div className="h-5 w-full bg-muted rounded-none"></div>
            <div className="h-5 w-2/3 bg-muted rounded-none"></div>
            <Separator className="mt-4" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex items-center gap-2 text-destructive p-4 border border-destructive/20 bg-destructive/5">
        <CircleAlert className="size-5" />
        <p className="text-sm">Impossibile caricare le ultime notizie. Riprova più tardi.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground text-sm">Nessun aggiornamento normativo disponibile al momento.</p>;
  }
  return <div className="flex flex-col gap-6">
      {posts.map((post, i) => {
      const dateObj = post.date ? new Date(post.date) : new Date();
      const formattedDate = dateObj.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
      return <article key={post.id} data-index={i} className="group flex flex-col gap-3">
            <div className="flex items-center gap-2 flex-wrap">
              <Badge variant="secondary" className="rounded-none font-mono text-xs border-border">
                <SafeHydrate><Calendar className="size-3 mr-1" /></SafeHydrate>
                {formattedDate}
              </Badge>
              <Badge variant="default" className="rounded-none text-xs bg-primary text-primary-foreground">
                Normativa
              </Badge>
            </div>
            
            <h4 className="text-lg font-semibold leading-tight group-hover:text-accent transition-colors line-clamp-2">
              {post.title}
            </h4>
            
            {post.excerpt && <div className="text-sm text-muted-foreground line-clamp-2" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}

            {post.link && <Link to={post.link} className="inline-flex items-center text-sm font-medium text-primary hover:text-accent transition-colors mt-1">
                Leggi approfondimento <ArrowRight className="ml-1 size-4" />
              </Link>}
            
            {i < posts.length - 1 && <Separator className="mt-4" />}
          </article>;
    })}
    </div>;
}
export default function NewsETestimonianze() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}